/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalibrationSavedPayload
 */
export interface CalibrationSavedPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: CalibrationSavedPayloadTypeEnum;
    /**
     * 
     */
    calibration: { [key: string]: any; };
}


/**
 * @export
 */
export const CalibrationSavedPayloadTypeEnum = {
    CalibrationSaved: 'calibration_saved',
} as const;
export type CalibrationSavedPayloadTypeEnum = typeof CalibrationSavedPayloadTypeEnum[keyof typeof CalibrationSavedPayloadTypeEnum];


/**
 * Check if a given object implements the CalibrationSavedPayload interface.
 */
export function instanceOfCalibrationSavedPayload(value: object): value is CalibrationSavedPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'calibration_saved') return false;
    
    if (!('calibration' in value) || value['calibration'] === undefined) return false;
    return true;
}

export function CalibrationSavedPayloadFromJSON(json: any): CalibrationSavedPayload {
    return CalibrationSavedPayloadFromJSONTyped(json, false);
}

export function CalibrationSavedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationSavedPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'calibration': json['calibration'],
    };
}

export function CalibrationSavedPayloadToJSON(json: any): CalibrationSavedPayload {
    return CalibrationSavedPayloadToJSONTyped(json, false);
}

export function CalibrationSavedPayloadToJSONTyped(value?: CalibrationSavedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'calibration': value['calibration'],
    };
}

